import { NAV_LINKS } from "@/components/Header";
import { scrollTo } from "@/lib/scroll";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-[#1A1A1A] pb-10 pt-20 text-[#FAF7F2]">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="grid gap-12 border-b border-[#FAF7F2]/10 pb-14 md:grid-cols-3">
                    <div>
                        <img
                            src="/assets/logo-pink.png"
                            alt="GPS srls - Recruiting and Learning"
                            className="h-24 w-auto object-contain"
                        />
                        <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#FAF7F2]/50">
                            Consulenza, formazione e sviluppo. Ti portiamo verso il tuo obiettivo, passo dopo passo.
                        </p>
                    </div>
                    <div>
                        <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#D4A5A5]">Link rapidi</p>
                        <nav className="mt-6 grid grid-cols-2 gap-x-6 gap-y-3" aria-label="Link footer">
                            {NAV_LINKS.map((l) => (
                                <button
                                    key={l.target}
                                    data-testid={`footer-${l.testid}`}
                                    onClick={() => scrollTo(l.target)}
                                    className="text-left text-sm text-[#FAF7F2]/70 transition-colors hover:text-[#D4A5A5]"
                                >
                                    {l.label}
                                </button>
                            ))}
                        </nav>
                    </div>
                    <div>
                        <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#D4A5A5]">Contatti</p>
                        <div className="mt-6 space-y-3 text-sm text-[#FAF7F2]/70">
                            <p>
                                <a href="mailto:info@gpsrls.com" className="transition-colors hover:text-[#D4A5A5]">
                                    info@gpsrls.com
                                </a>
                            </p>
                            <p>
                                <a href="tel:+393926464619" className="transition-colors hover:text-[#D4A5A5]">
                                    392 646 4619
                                </a>
                            </p>
                            <p>Mirano (Venezia), Italia · Operiamo in tutta Italia</p>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center justify-between gap-4 pt-8 text-xs text-[#FAF7F2]/40 sm:flex-row">
                    <p data-testid="footer-copyright">© 2026 GPS srls · Tutti i diritti riservati · P.IVA in aggiornamento</p>
                    <p>Privacy Policy · Cookie Policy</p>
                </div>
            </div>
        </footer>
    );
}
